import { getCategoryName, NavigationLinks } from '@mewa/types';

import { ServiceSegmentLink } from '../components/header/types';

export const addServiceSegmentGroups = <
  T extends { name: string } | ServiceSegmentLink,
>(
  serviceSegmentOptions: T[],
  navigation: NavigationLinks['navigation'],
): (T & { groupName?: string })[] =>
  serviceSegmentOptions.map((option) =>
    'category' in option
      ? { ...option, groupName: getCategoryName(option, navigation) }
      : { ...option },
  );

export const groupItemsByCategory = <
  T extends { name: string; groupName?: string },
>(
  items: T[],
) =>
  items.reduce<Record<string, (T & { index: number })[]>>(
    (groups, serviceSegment, index) => {
      const groupName = serviceSegment.groupName ?? '';
      if (groups[groupName]) {
        groups[groupName].push({ ...serviceSegment, index });
      } else {
        groups[groupName] = [{ ...serviceSegment, index }];
      }

      return groups;
    },
    {},
  );

export const convertToSingleGroupOptions = <T>(options: T[]) => ({
  '': options.map((option, index) => ({ ...option, index })),
});
